"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User2FA = User2FA;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function User2FA(props) {
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var validators = (0, _react.useMemo)(function () {
    return [new _commons.Code2FAValidator()];
  }, []);
  var _useState = (0, _react.useState)({
      status: 'optional_pending'
    }),
    _useState2 = _slicedToArray(_useState, 2),
    mfaStatus = _useState2[0],
    setMfaStatus = _useState2[1];
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register;
  var onEnable2FA = function onEnable2FA() {
    feedbackContext.showBackdrop();
    (0, _api.enableMFA)(props.user.email).then(function (config) {
      setMfaStatus(config);
      feedbackContext.showSuccess((0, _core.translate)('users.security.enabling_2fa'));
      cleanForm(props.user);
    })["catch"](function (error) {
      return (0, _core.cognitoErrorTranslator)(error, feedbackContext.showError);
    })["finally"](feedbackContext.closeBackdrop);
  };
  var onConfirm2FA = function onConfirm2FA(event) {
    event.preventDefault();
    if (!isValid()) {
      return;
    }
    var request = bind();
    feedbackContext.showBackdrop();
    (0, _api.confirMFA)(request.code || '').then(function (config) {
      feedbackContext.showSuccess((0, _core.translate)('users.security.confirmed_2fa'));
      setMfaStatus(config);
      cleanForm(props.user);
    })["catch"](function (error) {
      return (0, _core.cognitoErrorTranslator)(error, feedbackContext.showError);
    })["finally"](feedbackContext.closeBackdrop);
  };
  var onDisable2FA = function onDisable2FA(event) {
    event.preventDefault();
    if (!isValid()) {
      return;
    }
    var request = bind();
    feedbackContext.showBackdrop();
    (0, _api.disableMFA)(request.code || '').then(function (config) {
      setMfaStatus(config);
      feedbackContext.showSuccess((0, _core.translate)('users.security.disabled_2fa'));
      cleanForm(props.user);
    })["catch"](function (error) {
      return (0, _core.cognitoErrorTranslator)(error, feedbackContext.showError);
    })["finally"](feedbackContext.closeBackdrop);
  };
  var cancel2FA = function cancel2FA() {
    setMfaStatus({
      status: 'optional_pending'
    });
  };
  var cleanForm = function cleanForm(user) {
    // clear()
    props.onUpdated(user);
  };
  (0, _react.useEffect)(function () {
    (0, _api.getMFASettings)().then(function (config) {
      setMfaStatus(config);
    })["catch"](function (err) {
      console.log(err);
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 3,
    alignContent: "center",
    alignItems: "center",
    justifyContent: "center"
  }, mfaStatus.status === 'optional_pending' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption"
  }, (0, _core.translate)('users.security.2fa_status.DISABLED'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    my: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    size: "large",
    onClick: onEnable2FA
  }, (0, _core.translate)('users.security.buttons.enable_2fa')))))), mfaStatus.status === 'not_verified' && mfaStatus.secretCode && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 3,
    alignItems: "flex-start",
    alignContent: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: mfaStatus.qrUrl,
    alt: "2FA QR"
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    md: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption"
  }, (0, _core.translate)('users.security.2fa_status.NOT_VERIFIED', {
    secret: mfaStatus.secretCode
  })), /*#__PURE__*/_react["default"].createElement("form", {
    autoComplete: "off",
    noValidate: true,
    onSubmit: onConfirm2FA
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: "text",
    name: "code",
    label: (0, _core.translate)('users.2fa_code'),
    register: register,
    required: true,
    validators: validators
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    my: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    fullWidth: true,
    size: "large"
  }, (0, _core.translate)('users.security.buttons.enable_2fa')))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: "button",
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    size: "large",
    onClick: cancel2FA
  }, (0, _core.translate)('users.security.buttons.disable_2fa')))))))), mfaStatus.status === 'active' && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement("form", {
    autoComplete: "off",
    noValidate: true,
    onSubmit: onDisable2FA
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption"
  }, (0, _core.translate)('users.security.2fa_status.ENABLED'))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: "text",
    name: "code",
    label: (0, _core.translate)('users.2fa_code'),
    register: register,
    required: true,
    validators: validators
  })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    my: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.Button, {
    type: "submit",
    variant: "contained",
    color: "primary",
    fullWidth: true,
    size: "large"
  }, (0, _core.translate)('users.security.buttons.disable_2fa'))))))));
}